import React, {useMemo} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

function DisablingSection({disabled, className, children}) {
	
	const _className = "StyledDisablingSection" + (className ? " " + className : "");
	
	const section = useMemo(() => {
		if (disabled) {
			return <StyledDisablingSection className={_className}>{children}</StyledDisablingSection>;
		} else {
			return children;
		}
	}, [disabled, children]);

	return <React.Fragment>{section}</React.Fragment>;
}

const StyledDisablingSection = styled.section`
	display: flex;
	align-items: center;
	pointer-events: none;
	opacity: 0.5;
	margin-left: auto;
	color: var(--blue-600);
`;

DisablingSection.propTypes = {
	disabled: PropTypes.bool,
	children: PropTypes.node
};

export default DisablingSection;
